import { useProductsTFunction } from '@retail/products/i18n';
import { TableBody, TableRow } from '@mui/material';
import { environmentKeys } from './helpers';
import { CheckIcon } from '@shared/custom-icons';
import { StyledKeyTableCell, StyledTableCell } from '../styles';
import { SupplierItemDocumentation } from '@retail/products/types';

interface Props {
  supplierItems: SupplierItemDocumentation[];
}

export const EnvironmentDocumentationTableBody = ({ supplierItems }: Props) => {
  const t = useProductsTFunction();

  return (
    <TableBody>
      {environmentKeys.map((key, rowIndex) => (
        <TableRow key={key}>
          <StyledKeyTableCell index={rowIndex}>
            {/* @ts-ignore */}
            {t(`products.mgItem.environmentDocumentation.${key as keyof typeof environmentKeys}`)}
          </StyledKeyTableCell>

          {supplierItems.map((supplierItem, supplierIndex) => (
            <StyledTableCell
              key={`${rowIndex}-${supplierItem.supplier || supplierIndex}`}
              align="center"
              index={rowIndex}
            >
              {supplierItem.environmentalDocumentation?.[key] ? (
                <CheckIcon fontSize="small" />
              ) : (
                '-'
              )}
            </StyledTableCell>
          ))}
        </TableRow>
      ))}
    </TableBody>
  );
};
